export default __webpack_public_path__ + "static/media/regulatory--no-bicycles-tractors-or-carts--g1.c9248372.png";